"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_AGENTS = void 0;
exports.USER_AGENTS = {
    MOZILLA_FIREFOX: 'Firefox',
    SAMSUNG_BROWSER: 'SamsungBrowser',
    OPERA: 'Opera',
    OPR: 'Opr',
    TRIDENT: 'Trident',
    EDGE: 'Edge',
    EDG: 'Edg',
    CHROME: 'Chrome',
    SAFARI: 'Safari',
};
